/* Exor Games — "Also at our other Exor locations" on single-card pages
   (owner, 2026-09-10: per-store stock).

   The six shops are separate Shopify stores with separate stock, so this
   store's product page cannot sell the others' copies. What it can do is
   say who else has the card: the worker's /sisterstock.json asks the other
   five stores' public search for the same card (same game, any printing)
   and answers each store's cheapest available copy, with a count when that
   store's product JSON still carries one. One line under the buy box, each
   store name linking to that store's own product page (its own cart,
   checkout and pickup). Nothing renders when no other store has it. */
(function () {
  'use strict';
  var W = 'https://exor-binder.nevski.workers.dev';
  var host = document.querySelector('[data-xg-sis]');
  if (!host) return;
  var name = (host.getAttribute('data-name') || '').trim();
  var game = host.getAttribute('data-game') || 'mtg';
  if (name.length < 2) return;
  // The full title names THIS printing (set bracket + collector number), so
  // the worker can rank the same printing first and label the others
  // (owner 2026-09-14: the Charizard band was pointing at other printings).
  var title = '';
  try {
    var pj = document.querySelector('script[id^="ProductJson-"]');
    if (pj) title = String((JSON.parse(pj.textContent) || {}).title || '');
  } catch (e) {}
  if (!title) { var h1 = document.querySelector('h1.product-single__title'); title = h1 ? h1.textContent.trim() : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  var st = document.createElement('style');
  st.textContent = '.xg-sis{margin:14px 0 6px;padding:12px 14px;border:1px solid var(--xg-border,#e3e7ea);border-radius:12px;background:var(--xg-surface,#fff);font-size:14px;line-height:1.5;color:var(--xg-text,#3d454b)}' +
    '.xg-sis__t{display:block;font-size:11.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--xg-muted,#707a83);margin-bottom:4px}' +
    '.xg-sis__l{display:flex;flex-wrap:wrap;gap:6px 14px;margin:0;padding:0;list-style:none}.xg-sis__l li{margin:0;list-style:none}' +
    '.xg-sis__l a{font-weight:700;color:var(--xg-red,#d62c28);text-decoration:none}.xg-sis__l a:hover{text-decoration:underline}' +
    '.xg-sis__l small{color:var(--xg-muted,#707a83)}.xg-sis__n{display:block;margin-top:4px;font-size:12px;color:var(--xg-muted,#707a83)}' +
    '.xg-sis__l--other{margin-top:2px}.xg-sis__l--other a{color:var(--xg-text,#3d454b)}';
  document.head.appendChild(st);
  var ctl = typeof AbortController === 'function' ? new AbortController() : null;
  var tmo = ctl ? setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 8000) : null;
  fetch(W + '/sisterstock.json?game=' + encodeURIComponent(game) + '&names=' + encodeURIComponent(name) + (title ? '&title=' + encodeURIComponent(title.slice(0, 160)) : ''), ctl ? { signal: ctl.signal } : {})
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
    .then(function (j) {
      if (tmo) clearTimeout(tmo);
      var res = j && j.results && j.results[0] && j.results[0].sister;
      var stores = res && res.stores && res.stores.length ? res.stores : (res ? [res] : []);
      if (!stores.length) return;
      // Same printing first (or everything, when the worker did not grade);
      // other printings on their own line, named by set and number.
      var exact = stores.filter(function (s) { return !s.printing || s.printing === 'exact'; });
      var others = stores.filter(function (s) { return s.printing && s.printing !== 'exact'; });
      function line(s, withSet) {
        var q = typeof s.qty === 'number' && s.qty > 0 ? (s.qty === 1 ? '1 left' : s.qty + ' in stock') : 'in stock';
        var cond = s.condition ? esc(s.condition) + (s.foil ? ' foil' : '') + ' · ' : (s.foil ? 'foil · ' : '');
        var pr = withSet && (s.set || s.num) ? ' <small>[' + esc((s.num ? s.num + ' ' : '') + (s.set || '')) + ']</small>' : '';
        return '<li><a href="' + esc(s.url) + '" rel="noopener">' + esc(s.store) + '</a>' + pr + ' <small>' + cond + 'from $' + esc(s.price) + ' · ' + q + '</small></li>';
      }
      var html = '<span class="xg-sis__t">Also at our other Exor locations</span>';
      if (exact.length) html += '<ul class="xg-sis__l">' + exact.map(function (s) { return line(s, false); }).join('') + '</ul>';
      if (others.length) html += '<span class="xg-sis__n">' + (exact.length ? 'Other printings: ' : 'Not this printing, but they have: ') + '</span><ul class="xg-sis__l xg-sis__l--other">' + others.map(function (s) { return line(s, true); }).join('') + '</ul>';
      html += '<span class="xg-sis__n">Separate stores with their own carts and pickup.' + (exact.length ? ' Prices are set store by store.' : '') + '</span>';
      host.innerHTML = html;
      host.className = 'xg-sis';
      host.hidden = false;
    })
    .catch(function () { if (tmo) clearTimeout(tmo); });
})();
